import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Thumbnail from '@components/@core/Thumbnail';
import { ProductCard } from '@components/CompanyCard';
import { hasHtml } from '~/services/util';

const Home = ({ data }) => (
    <>
        <div className="card premium-all p-3">
            <Row>
                <Col md={6}>
                    <Thumbnail source={data?.title_url} size="responsive" />
                </Col>
                <Col md={6}>
                    <p className="dsl-b18 bold pt-0 ssp-t-2">{data.name}</p>
                    {hasHtml(data.data?.description ?? '') ? <div dangerouslySetInnerHTML={{ __html: data.data.description }} /> : <p className="dsl-m16">{data.data.description}</p>}
                </Col>
            </Row>
        </div>
        <div className="card mt-3">
            <p className="dsl-b22 bold mb-0">All Products</p>
            <div className="d-flex flex-wrap">
                {data.products.map((item, index) => (
                    <ProductCard data={item} logo={data.avatar} key={index} />
                ))}
            </div>
        </div>
    </>
);

Home.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        avatar: PropTypes.string,
        business_id: PropTypes.number,
        cover_url: PropTypes.string,
        data: PropTypes.shape({
            description: PropTypes.string,
        }),
        products: PropTypes.array,
        title_url: PropTypes.string,
    }),
};

Home.defaultProps = {
    data: {
        id: 1,
        name: '',
        avatar: '',
        business_id: 1,
        cover_url: '',
        data: { description: '' },
        products: [],
        title_url: '',
    },
};

export default memo(Home);
